import { Component, HostListener, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    standalone: true,
    selector: 'button-scroll-to-top',
    templateUrl: './scroll-to-top.button.html',
    styleUrls: ['./scroll-to-top.button.scss'],
    imports: [MatButtonModule, MatIconModule]
})
export class ScrollToTopButton implements OnInit {
    isVisible = false;

    constructor() { }

    ngOnInit(): void {
        // Check initial scroll position
        this.checkScrollPosition();
    }

    @HostListener('window:scroll', [])
    onWindowScroll(): void {
        this.checkScrollPosition();
    }

    private checkScrollPosition(): void {
        // Show button when scrolled down more than 300px
        this.isVisible = window.pageYOffset > 300;
    }

    scrollToTop(): void {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
}